import React from "react";
import styles from "./ReconciliationByAccount.module.css";

const rows = [
  ["GTBank Main Account", "18,420", "98.2%", "₦0", "Good"],
  ["Access Bank Account", "12,840", "96.4%", "₦420K", "Review"],
  ["Zenith Collection Account", "24,120", "92.8%", "2.1M", "Attention"],
  ["UBA Payments Account", "8,210", "97.1%", "₦120K", "Review"],
  ["Fidelity Savings Account", "6,110", "99.2%", "₦0", "Good"],
];

const StatusBadge = ({ status }) => {
  const cls = status === "Good" ? styles.good : status === "Review" ? styles.review : styles.attention;
  return <span className={`${styles.badge} ${cls}`}>{status}</span>;
};

const ReconciliationByAccount = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Reconciliation by Account</h3>
        {/* <a className={styles.viewAll} href="#">View all</a> */}
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Account</th>
              <th>Transactions</th>
              <th>Match Rate</th>
              <th>Variance</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className={i !== rows.length - 1 ? styles.row : ""}>
                <td title={r[0]}>{r[0]}</td>
                <td className={styles.mono}>{r[1]}</td>
                <td className={styles.mono}>{r[2]}</td>
                <td className={styles.mono}>{r[3]}</td>
                <td><StatusBadge status={r[4]} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReconciliationByAccount;
